import {
  FETCH_DWK_COM_PROJECTS,
  FETCH_DWK_COM_PROJECT,
  SEARCH_DWK_COM_PROJECTS,
  FETCHING_DWK_COM_PROJECTS,
} from '../actions/types';

const INITIAL_STATE = { 
  city:'', 
  fetching:true,  
  projectComs: [],
  projectComsForData :[],
  projectCom: null,
  offset: 0,
  limit: 10,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case FETCH_DWK_COM_PROJECTS:
      return { ...state, ...action.payload };
    case FETCH_DWK_COM_PROJECT:
      return { ...state, projectCom: action.payload };
    
    case SEARCH_DWK_COM_PROJECTS:
     
      return { ...state, ...action.payload };
    
    case FETCHING_DWK_COM_PROJECTS:
      return { ...state, fetching: action.payload };
    default:
      return state;
  }
};
